export const sentimentEditStatusOptions = [
  {
    text: 'Manual Edited Sentiment',
    value: 'manual_edited',
  },
  {
    text: 'Auto Generated Sentiment',
    value: 'unedited',
  },
];
